/**
 * Internal helpers for the Salvation services (not exported from the barrel).
 */
/** Return response.data or throw `message` when the envelope carries no data. */
export function unwrapSalvationResponse(response, message) {
    if (response.data === undefined || response.data === null)
        throw new Error(message);
    return response.data;
}
/** Array endpoints: the data, else an empty list. */
export function salvationListOrEmpty(response) {
    return response.data ?? [];
}
//# sourceMappingURL=unwrapSalvationResponse.js.map